const layout = () => import('@/views/layout')
const marketFund = () => import('@/views/fund/marketFund')
/* 
 * 营销基金
*/
export default [
  {
    path: '/fund',
    name: 'fund',
    redirect: '/fund/marketFund',
    component: layout,
    hidden: true,
    children: [
      { path: 'marketFund', name: 'marketFund', component: marketFund, hidden: true, meta: { title: '营销基金', scrollToTop: true } }
    ]
  }
]